import "./App.css";
import Header from "./Components/Header/Header";
import Scores from "./Components/Scores/Scores";
import Footer from "./Components/Footer/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <Scores />
      <Footer />
    </div>
  );
}

export default App;
